import React from 'react';

const EnterpriseEdition = () => {
  return (
    <div className="doc-content">
      <div className="quickstart-header">
        <p className="quickstart-category">Getting Started</p>
        <h1>Enterprise Edition</h1>
      </div>
      
      <div className="info-banner">
        <i className="fa-solid fa-info-circle"></i>
        <div>
          <p>For organizations requiring maximum security, customization, control and best quality with enterprise-grade features.</p>
        </div>
      </div>
      
      <p>Designed for <strong>organizations</strong> that need maximum security, customization, and control.</p>
      
      <p>Get <strong>enterprise-grade features</strong> with dedicated support and custom development options.</p>
      
      <div className="platform-cards">
        <div className="platform-card">
          <div className="card-icon">
            <i className="fa-solid fa-certificate"></i>
          </div>
          <h3>Commercial License</h3>
          <p>Full proprietary features, commercial usage rights, and white-labeling options for your business.</p>
        </div>
        
        <div className="platform-card">
          <div className="card-icon">
            <i className="fa-solid fa-code"></i>
          </div>
          <h3>Custom Development</h3>
          <p>SSO/RBAC integration and dedicated algorithm team for scenario-specific framework optimization.</p>
        </div>
      </div>
      
      <div className="platform-cards">
        <div className="platform-card">
          <div className="card-icon">
            <i className="fa-solid fa-chart-pie"></i>
          </div>
          <h3>Intelligence & Analytics</h3>
          <p>User behavior analysis, real-time production monitoring, and automated agent optimization.</p>
        </div>
        
        <div className="platform-card">
          <div className="card-icon">
            <i className="fa-solid fa-headset"></i>
          </div>
          <h3>Premium Support</h3>
          <p>24/7 dedicated support, custom SLAs, and professional implementation services.</p>
        </div>
      </div>
      
      <div className="platform-section">
        <h2>Enterprise Solutions</h2>
        
        <p>Our enterprise offerings are tailored to your organization's specific needs and scale. We work with you to create a custom solution that fits your requirements and budget.</p>
        
        <div className="platform-cards">
          <div className="platform-card">
            <div className="card-icon">
              <i className="fa-solid fa-building"></i>
            </div>
            <h3>Starter Package</h3>
            <ul style={{textAlign: 'left', margin: '1rem 0'}}>
              <li>Commercial license included</li>
              <li>Email support with SLA</li>
              <li>Basic analytics dashboard</li>
              <li>Standard uptime guarantee</li>
              <li>Integration assistance</li>
            </ul>
          </div>
          
          <div className="platform-card" style={{border: '2px solid #10b981', backgroundColor: '#f0fdf4'}}>
            <div className="card-icon">
              <i className="fa-solid fa-crown"></i>
            </div>
            <h3>Professional Package</h3>
            <ul style={{textAlign: 'left', margin: '1rem 0'}}>
              <li>Unlimited memory operations</li>
              <li>Custom development hours included</li>
              <li>Priority support with faster response</li>
              <li>Advanced analytics & monitoring</li>
              <li>Premium SLA with higher uptime</li>
              <li>SSO/RBAC integration</li>
            </ul>
            <div style={{background: '#10b981', color: 'white', padding: '0.5rem', borderRadius: '4px', fontSize: '0.875rem', fontWeight: 'bold', textAlign: 'center', margin: '1rem 0'}}>
              MOST POPULAR
            </div>
          </div>
          
          <div className="platform-card">
            <div className="card-icon">
              <i className="fa-solid fa-rocket"></i>
            </div>
            <h3>Custom Enterprise</h3>
            <ul style={{textAlign: 'left', margin: '1rem 0'}}>
              <li>Volume-based pricing</li>
              <li>Unlimited custom development</li>
              <li>24/7 dedicated support</li>
              <li>Custom SLA agreements</li>
              <li>On-premise deployment</li>
              <li>White-label solutions</li>
            </ul>
          </div>
        </div>
        
        <h2>Get Started</h2>
        
        <div className="info-banner" style={{backgroundColor: '#eff6ff', borderLeft: '4px solid #3b82f6'}}>
          <i className="fa-solid fa-handshake" style={{color: '#3b82f6'}}></i>
          <div>
            <p><strong>Ready to get started?</strong> Contact our enterprise team to discuss your specific needs and get a custom quote.</p>
          </div>
        </div>
        
        <div className="platform-cards">
          <div className="platform-card">
            <div className="card-icon">
              <i className="fa-solid fa-calendar"></i>
            </div>
            <h3>Schedule a Demo</h3>
            <p>See MemU Enterprise in action with a personalized demonstration.</p>
            <a href="mailto:enterprise@nevamind.ai?subject=MemU Enterprise Demo Request" className="getting-started-link">Book Demo →</a>
          </div>
          
          <div className="platform-card">
            <div className="card-icon">
              <i className="fa-solid fa-comments"></i>
            </div>
            <h3>Technical Consultation</h3>
            <p>Discuss your technical requirements with our architecture team.</p>
            <a href="mailto:enterprise@nevamind.ai?subject=MemU Technical Consultation" className="getting-started-link">Get Consultation →</a>
          </div>
          
          <div className="platform-card">
            <div className="card-icon">
              <i className="fa-solid fa-file-contract"></i>
            </div>
            <h3>Custom Quote</h3>
            <p>Get a personalized quote based on your specific use case and volume.</p>
            <a href="mailto:enterprise@nevamind.ai?subject=MemU Enterprise Quote Request" className="getting-started-link">Request Quote →</a>
          </div>
        </div>
        
        <h2>Enterprise Support</h2>
        
        <h3>What's Included</h3>
        <ul>
          <li><strong>Dedicated Account Manager:</strong> Your single point of contact for all enterprise needs</li>
          <li><strong>Technical Support:</strong> Direct access to our engineering team</li>
          <li><strong>Custom Integration:</strong> Help with SSO, RBAC, and third-party integrations</li>
          <li><strong>Performance Optimization:</strong> Tailored configurations for your specific workload</li>
          <li><strong>Training & Onboarding:</strong> Comprehensive training for your development team</li>
        </ul>
        
        <h3>Contact Information</h3>
        <div className="platform-cards">
          <div className="platform-card">
            <div className="card-icon">
              <i className="fa-solid fa-envelope"></i>
            </div>
            <h3>Email</h3>
            <p><a href="mailto:enterprise@nevamind.ai">enterprise@nevamind.ai</a></p>
          </div>
          
          <div className="platform-card">
            <div className="card-icon">
              <i className="fa-solid fa-phone"></i>
            </div>
            <h3>Sales Hotline</h3>
            <p><a href="tel:+1-555-MEMU-ENT">+1 (555) MEMU-ENT</a></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnterpriseEdition;